import Vue from 'vue'

// Lib imports
import axios from 'axios'

 //axios.defaults.baseURL = 'http://localhost:8000/'

 //axios.defaults.baseURL = 'http://erec.test/'

 //axios.defaults.baseURL = 'https://erec.api.beta.dzale.com/'

//axios.defaults.baseURL = 'https://erec.api.dlv.dzale.com/'

//axios.defaults.baseURL = 'https://erec.api.boki.dzale.com/'

//axios.defaults.baseURL = 'https://erec.api.dzale.com/'

axios.defaults.baseURL = 'https://api.ereciklaza.com/'

axios.defaults.storageURL = axios.defaults.baseURL + 'storage/'

Vue.prototype.$http = axios
